import { Navbar } from "../components/Navbar";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Services } from "../components/sections/Services";
import { WhyUs } from "../components/sections/WhyUs";
import { Partners } from "../components/sections/Partners";
import { DeliveryModel } from "../components/sections/DeliveryModel";
import { BestFit } from "../components/sections/BestFit";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyUs />
        <Partners />
        <DeliveryModel />
        <BestFit />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
